<div class="middle-box text-center loginscreen  animated fadeInDown">
    <h2>RAF Electric</h2>
    <div style="margin-top: 25px;">v{{ appInfo.appVersion }}</div>
</div>

<div style="margin-top: 100px; margin-left: 50px;"><a href (click)="logout()">log out</a></div>
